import Marquee from "react-fast-marquee";

const WORDS = [
  "This Is More Than Training",
  "This Is Transformation",
  "Training With Purpose",
  "Growing With Passion",
  "Creating Futures",
];

export const BrandMarquee = () => (
  <section data-testid="marquee" className="bg-cream py-8 border-y border-wine/10 overflow-hidden">
    <Marquee speed={45} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <div key={i} className="flex items-center">
          <span className="font-display italic text-wine text-4xl sm:text-5xl px-8">{w}</span>
          <span className="text-gold text-3xl">✦</span>
        </div>
      ))}
    </Marquee>
  </section>
);
